import { equals } from "ramda";

////////// AWS SDK PART SIZE UPLOAD LIMIT
export const ACL_PUBLIC_READ = 'public-read';

export const TRUE = 'true';
export const FALSE = 'false';
////////////////////////////////
const DEVELOPMENT = 'development';
const PRODUCTION = 'production';

export const LOCAL_ENVIRONMENT = process.env.LOCAL_ENVIRONMENT || 'development'
export const ENVIRONMENT = process.env.NODE_ENV;
export const isDevelopment = ENVIRONMENT === DEVELOPMENT;
export const PUB_LOCATION = "https://lendsmartpub.s3.us-east-2.amazonaws.com"
export const DEV_PUB_LOCATION = 'https://attune-development-pub.s3.us-east-1.amazonaws.com'
export const DEFAULT_S3_PUB_LOCATION = isDevelopment ?
  DEV_PUB_LOCATION : PUB_LOCATION;
export const LENDSMARTPUB_BUCKET =  isDevelopment ? 'attune-development-pub':'lendsmartpub';
const isLocalConfigEnabled = process.env.REACT_APP_USE_LOCAL_CONFIG === TRUE;
export const canUseLocalDevelopmentConfig =
  isDevelopment && isLocalConfigEnabled;
export const isProduction = ENVIRONMENT === PRODUCTION;

export const REACT_REMOTE_APP_ENVIRONMENT = process.env.REACT_APP_ENVIRONMENT;

const AUTH_COOKIE = 'cookie'
export const DEFAULT_CORE_API_AUTH = AUTH_COOKIE


// The default locale is US
const US = 'us';
export const LOCALE_DOWNCASE = US;

/// The default currency is USD
export const CURRENCY = 'USD';
export const SMARTLOOK_PROJECT_ID =
  process.env.REACT_APP_SMARTLOOK_ID ||
  '2353efdf698e516c38029b410b1a5f0cb43286e5';

export const WORKLET_API_AUTH_TOKEN =
  process.env.REACT_APP_WORKLET_API_AUTH_TOKEN;

// Dont't change this name, this is used as a filler for passwords
export const APP_FILLER = 'Lendsmart';

export const YES = 'yes';
export const NO = 'no';

export const COUNTRY_CODE_EXTENSION = '1';

const getAPIRoot = () => {
  return isDevelopment ? `https://${window.location.hostname}:${'3000'}/api/v1`:
    process.env.REACT_APP_WHITELABEL_API_ROOT || 'https://devapi.lendsmart.ai/api/v1';
}
// 1. Core API
export const API_ROOT = getAPIRoot()

export const GRAPHQL_ENDPOINT = process.env.REACT_APP_GRAPHQL_ENDPOINT;

export const SENTRY_URL = '';

export const ISO_FORMAT = 'YYYY-MM-DD HH:mm:ss';

export const PUBNUB_PUBLISH_KEY =
  process.env.REACT_APP_WHITELABEL_PUBNUB_PUBLISH_KEY ||
  'pub-c-3f94708c-1d82-46d4-910c-a1767f8536b8';

export const PUBNUB_SUBSCRIBE_KEY =
  process.env.REACT_APP_WHITELABEL_PUBNUB_SUBSCRIBE_KEY ||
  'sub-c-099e6592-4fc6-11e9-bc27-728c10c631fc';

const PUBNUB_AUTH_KEY =
  process.env.REACT_APP_WHITELABEL_PUBNUB_AUTH_KEY ||
  'sec-c-ODQ2ZjhkYjItN2M1YS00OTExLThkMmQtMDI5OTNhYzZhN2M5';

export const PUBNUB_AUTH = {
  publishKey: PUBNUB_PUBLISH_KEY,
  subscribeKey: PUBNUB_SUBSCRIBE_KEY,
  presenceTimeout: 30,
  authKey: PUBNUB_AUTH_KEY,
  logVerbosity: true,
};

//in namespace not used more than 19 didgit
export const BREAKOUT_NAMESPACE_ID = '1584545454845214888';
export const SUTTONBANK_NAMESPACE_ID = '1876145110408773632';
export const APP_LS_NAMESPACE_ID = '1871588045099114496';
export const CSBNET_NAMESPACE_ID = '1972529917745471488';
export const MIDWESTBANK_NAMESPACE_ID = '2022497368012800000';
export const RSNT_NAMESPACE_ID = '2227463123652919296';
export const FIRST_CBT_NAMESPACE_ID = '2027453443778854912';
export const STAR_BANK_NAMESPACE_ID = '2374577388138086400';
export const TEXAS_SECURITY_NAMESPACE_ID = '2772566680807211008';


export const ENVIRONMENT_UAT = 'uat';
export const ENVIRONMENT_PROD = 'production';
export const ENVIRONMENT_DEV = 'development';




// ROLES USED BY RESIDENTIAL MortgageRoute
export const ROLE_BORROWER = 'borrower';
export const ROLE_COBORROWER = 'coborrower';

export const ROLE_APPLICANT = 'applicant';
export const ROLE_COAPPLICANT = 'coapplicant';

export const APPLICANT = 'Applicant';
export const CO_APPLICANT = 'Co-Applicant';
export const LOAN_ROLE_NAME = (loanRole: string) => equals(ROLE_COBORROWER, loanRole) ? CO_APPLICANT: APPLICANT;

// S3 AI DETFAULT BUCKET NAME

//E Disclosure
export const E_DISCLOSURE_SITE_ID =
  process.env.REACT_APP_E_DISCLOSURE_SITE_ID || '';

export const ASSET_PLAID_SUCESS = 'plaid_asset_updated';
export const INCOME_PLAID_SUCESS = 'plaid_income_updated';

export const RAILZ_TEXT = 'railz';

export const DEFAULT_PHONE_CODE = 'us';
export const DISABLE_COUNTRY_CODE = true;
export const BANK_HOLIDAYS_COUNTRY = 'US';
export const API_MAX_PAGE_SIZE = 25;
export const MIN_PAGE_SIZE = 25;

// The default widget_id when not configured, applies to all sandbox
export const RAILZ_WIDGET_ID =
  process.env.REACT_APP_WHITELABEL_RAILZ_WIDGET_ID ||
  'sb_prod_90d8f293-9f22-478d-bf6f-230278451f1b';

// Default error message for non-API errors
export const DEFAULT_ERROR_MESSAGE = 'An unexpected error occurred.';

export const AUTH0_CLIENT_SECRET =
  process.env.REACT_APP_AUTH0_CLIENT_SECRET ||
  'PVL3w9dEDDwucdcSD5Wz3JCImMgRL9RU';

export const AUTH0_CLIENT_DOMAIN =
  process.env.REACT_APP_AUTH0_CLIENT_DOMAIN || 'dev-g9d-2zme.us.auth0.com';
export const PLAID_LINK_CUSTOMIZATION_NAME =
  process.env.REACT_APP_PLAID_LINK_CUSTOMIZATION_NAME || '';
export const APP_LS_NAMESPACE = 'app';
export const BREAKOUT_NAMESPACE = 'breakoutfinance';
export const MIDWESTBANK_NAMESPACE = 'mbwi';
export const SUTTONBANK_NAMESPACE = 'suttonbank';
export const RSNT_NAMESPACE = 'rsnt';
export const CSBNET_NAMESPACE = 'csbnet';
export const FIRSTCBT_NAMESPACE = 'firstcbt';
export const STARBANK_NAMESPACE = 'starbank';
export const TEXASSECURITYBANK_NAMESPACE = 'texassecuritybank';

export const EMPTY_ADDRESS_MESSAGE = "I can't find the address";

export const TERM_OF_USE_HBS = 'terms_of_use_lendsmart.hbs';
export const PRIVACY_POLICY_HBS = 'lendsmart_privacy_policy.hbs';
export const CARD_HOLDER_AGREEMENT_HBS = 'card_holder_agreement.hbs';
export const PRICING_TERMS_HBS = 'lendsmart_pricing_terms.hbs';
export const CONSENT_HBS =
  'consent_to_use_electronic_signatures_and_records_lendsmart_template.hbs';
export const RENASANT_PRIVACY_HBS = 'renasant_privacy_policy_v2.hbs';
export const RENASANT_TERMS_HBS = 'terms_of_use_renasant.hbs';
export const DIGITAL_TERMS_HBS = 'digital-banking-consent.hbs';
export const E_STATEMENTS_TERMS_HBS = 'consent_to_use_electronic_communications_agreement+_template.hbs';
export const CREDIT_CONSENT = 'renasant_credit_consent.hbs';
export const STAR_CREDIT_CONSENT = 'starbank_credit_consent.hbs';
export const COOKIE_POLICY_CONSENT = 'cookie_policy.hbs';

export const TERM_OF_USE = 'Terms of Use';
export const PRIVACY_POLICY = 'Privacy Policy';
export const CONSENT = 'Consent to use Electronic Signature and Records';
export const CARD_HOLDER_AGREEMENT = 'Cardholder Agreement';
export const PRICING_AND_TERMS = 'Pricing and Terms';
export const RENASANT_BANK_TERMS_OF_USE = 'Renasant Bank Terms of Use';
export const RENASANT_BANK_PRIVACY_POLICY = 'Renasant Bank Privacy Policy';
export const ATTUNE_TERMS_OF_USE = 'ATTUNE Terms of Use';
export const ATTUNE_PRIVACY_POLICY = 'ATTUNE Privacy Policy';
export const CONSENT_DIGITAL = 'Enroll to Digital Banking';
export const CONSENT_E_STATEMENTS = 'Enroll for paperless statements (E-statements)';
export const RSNT_CREDIT_POLICY = 'Renasant Credit Consent';
export const STAR_CREDIT_POLICY = 'Starbank Credit Consent';


